import store from 'src/js/store';
import showAnchors from '../actions/show-anchors';

const show = (elements) => {
  store.dispatch(showAnchors(elements));
};

export default show;
